<div class="syncing-state-container" *ngIf="displayData">
  <div class="progress-bar-container">
    <div class="progress-bar">
      <mat-progress-spinner
        *ngIf="data.status === 'Started'"
        mode="indeterminate"
        [diameter]="60"
        [strokeWidth]="1"
        @pulse
      ></mat-progress-spinner>
      <u-icon *ngIf="displayData.icon" class="icon" [model]="{ type: 'img', value: displayData.icon }"></u-icon>
      <indicator *ngIf="data.status === 'Failed'" [intent]="'danger'"></indicator>
    </div>
  </div>
  <div *ngIf="displayData.title" @fade class="title">
    {{ displayData.title }}
  </div>
  <div *ngIf="displayData.account" @fade class="account">
    <account-icon
      *ngIf="displayData.account.icon"
      [initials]="displayData.account.icon.value.value.initials"
      [size]="'16px'"
    ></account-icon>
    <span class="name">{{ displayData.account.name }}</span>
  </div>
  <div *ngIf="displayData.subtitle" @fade class="subtitle">
    {{ displayData.subtitle }}{{ !displayData.account ? 's' : '' }}
    {{ displayData.note }}
  </div>
</div>
